const phonemodel = {
  getlist: 'phonemodel/getlist',
  add: 'phonemodel/add',
  update: 'phonemodel/update',
  remove: 'phonemodel/remove',
  get: 'phonemodel/get',
  getall: 'phonemodel/getall',
  clearcache: 'phonemodel/clear-cache',
}
export default phonemodel
